import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "align-top" }
const _hoisted_2 = {
  key: 0,
  class: "form-group mb-0"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "align-top" }
const _hoisted_5 = {
  key: 0,
  class: "form-group mb-0"
}
const _hoisted_6 = { class: "input-group date datepickerInput" }
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_9 = {
  key: 1,
  class: "form-group mb-0"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "input-group date datepickerInput" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    class: "form-control",
    placeholder: "MM/DD/YYYY",
    autocomplete: "off",
    disabled: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_11 = { class: "form-check pt-0 ps-4 form-check-inline" }
const _hoisted_12 = ["id"]
const _hoisted_13 = ["for"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Unknown", -1 /* HOISTED */)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "align-top" }
const _hoisted_18 = {
  key: 0,
  class: "form-group mb-0"
}
const _hoisted_19 = { class: "input-group date datepickerInput" }
const _hoisted_20 = ["value"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_22 = {
  key: 1,
  class: "form-group mb-0"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "input-group date datepickerInput" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    class: "form-control",
    placeholder: "MM/DD/YYYY",
    autocomplete: "off",
    disabled: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_24 = { class: "form-check pt-0 ps-4 form-check-inline" }
const _hoisted_25 = ["id"]
const _hoisted_26 = ["for"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Unknown", -1 /* HOISTED */)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 0,
  class: "text-end"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1 /* HOISTED */)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 0,
  class: "btn-group table-btn-group"
}
const _hoisted_36 = ["id"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h" }, null, -1 /* HOISTED */)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = ["aria-labelledby"]
const _hoisted_40 = ["colspan"]
const _hoisted_41 = {
  key: 2,
  class: "button-cell text-end"
}
const _hoisted_42 = {
  key: 3,
  class: "button-cell text-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TablePrompt = _resolveComponent("TablePrompt")!

  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass(`${_ctx.isEditRequested || _ctx.isDeleteRequested || _ctx.isAddRequested ? 'edit-row' : ''}`)
  }, [
    _createElementVNode("td", _hoisted_1, [
      (_ctx.isEditRequested || _ctx.isAddRequested)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_TypeaheadInput, {
              getData: _ctx.getProblemsList,
              value: _ctx.selectedProblem,
              placeholder: "Search for Problem",
              "init-value": _ctx.selectedProblem,
              onValueChanged: _ctx.handleProblemChange
            }, null, 8 /* PROPS */, ["getData", "value", "init-value", "onValueChanged"])
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.problem.description
            }, null, 8 /* PROPS */, ["text"])
          ]))
    ]),
    _createElementVNode("td", _hoisted_4, [
      (_ctx.isEditRequested || _ctx.isAddRequested)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!_ctx.problem.isStartDateUnknown)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_DatePicker, { getDate: _ctx.handleDateChange }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("input", {
                          name: "startDate",
                          type: "text",
                          class: "form-control",
                          placeholder: "MM/DD/YYYY",
                          value: _ctx.formatDateInput(_ctx.problem.startDate),
                          autocomplete: "off",
                          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args)))
                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_7),
                        _hoisted_8
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["getDate"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_DatePicker, null, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1 /* STABLE */
                  })
                ])),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input au-target",
                id: `start-${_ctx.currentView}-${_ctx.index}`,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.problem.isStartDateUnknown) = $event))
              }, null, 8 /* PROPS */, _hoisted_12), [
                [_vModelCheckbox, _ctx.problem.isStartDateUnknown]
              ]),
              _createElementVNode("label", {
                class: "form-check-label",
                for: `start-${_ctx.currentView}-${_ctx.index}`
              }, _hoisted_15, 8 /* PROPS */, _hoisted_13)
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.problem.isStartDateUnknown)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Unknown"))
              : (_openBlock(), _createBlock(_component_EmptyTextHandler, {
                  key: 1,
                  text: _ctx.formatDate(_ctx.problem.startDate)
                }, null, 8 /* PROPS */, ["text"]))
          ], 64 /* STABLE_FRAGMENT */))
    ]),
    _createElementVNode("td", _hoisted_17, [
      (_ctx.isEditRequested || _ctx.isAddRequested)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!_ctx.problem.isResolvedDateUnknown)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_DatePicker, { getDate: _ctx.handleDateChange }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("input", {
                          name: "resolvedDate",
                          type: "text",
                          class: "form-control",
                          placeholder: "MM/DD/YYYY",
                          value: _ctx.formatDateInput(_ctx.problem.resolvedDate),
                          autocomplete: "off",
                          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args)))
                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_20),
                        _hoisted_21
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["getDate"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createVNode(_component_DatePicker, null, {
                    default: _withCtx(() => [
                      _hoisted_23
                    ]),
                    _: 1 /* STABLE */
                  })
                ])),
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input au-target",
                id: `resolve-${_ctx.currentView}-${_ctx.index}`,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.problem.isResolvedDateUnknown) = $event))
              }, null, 8 /* PROPS */, _hoisted_25), [
                [_vModelCheckbox, _ctx.problem.isResolvedDateUnknown]
              ]),
              _createElementVNode("label", {
                class: "form-check-label",
                for: `resolve-${_ctx.currentView}-${_ctx.index}`
              }, _hoisted_28, 8 /* PROPS */, _hoisted_26)
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.problem.isResolvedDateUnknown)
              ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Unknown"))
              : (_openBlock(), _createBlock(_component_EmptyTextHandler, {
                  key: 1,
                  text: _ctx.formatDate(_ctx.problem.resolvedDate)
                }, null, 8 /* PROPS */, ["text"]))
          ], 64 /* STABLE_FRAGMENT */))
    ]),
    (!_ctx.isEditRequested && !_ctx.isDeleteRequested && !_ctx.isAddRequested)
      ? (_openBlock(), _createElementBlock("td", _hoisted_30, [
          _createElementVNode("button", {
            class: "btn table-btn btn-outline-info",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openEditProblem()))
          }, _hoisted_32),
          _createElementVNode("button", {
            class: "btn table-btn btn-outline-danger",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openDeleteProblem()))
          }, _hoisted_34),
          (_ctx.problemsLength > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn px-1 py-0 btn-outline-primary dropdown-toggle",
                  "data-bs-toggle": "dropdown",
                  id: `ProbelmsRow${_ctx.problem.resolvedOrder}`
                }, _hoisted_38, 8 /* PROPS */, _hoisted_36),
                _createElementVNode("div", {
                  class: "dropdown-menu",
                  "aria-labelledby": `ProbelmsRow${_ctx.problem.resolvedOrder}`
                }, [
                  (!_ctx.first)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "dropdown-item",
                        href: "javascript:void(0);",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.moveProblemUp(_ctx.index, _ctx.index - 1)))
                      }, " Move up "))
                    : _createCommentVNode("v-if", true),
                  (!_ctx.last)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "dropdown-item",
                        href: "javascript:void(0);",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.moveProblemDown(_ctx.index, _ctx.index + 1)))
                      }, " Move down "))
                    : _createCommentVNode("v-if", true)
                ], 8 /* PROPS */, _hoisted_39)
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.isDeleteRequested)
      ? (_openBlock(), _createElementBlock("td", {
          key: 1,
          colspan: _ctx.columns,
          class: "p-2 text-end"
        }, [
          _createVNode(_component_TablePrompt, {
            "ok-text": "Delete",
            name: "delete",
            ok: _ctx.handleDeleteProblem,
            cancel: _ctx.cancelDeleteRequest,
            message: _ctx.deleteMessage,
            "cancel-text": "No",
            "include-yes": false
          }, null, 8 /* PROPS */, ["ok", "cancel", "message"])
        ], 8 /* PROPS */, _hoisted_40))
      : _createCommentVNode("v-if", true),
    (_ctx.isEditRequested)
      ? (_openBlock(), _createElementBlock("td", _hoisted_41, [
          _createElementVNode("button", {
            type: "button",
            class: "btn table-btn btn-outline-success",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.saveEditProblem()))
          }, "Add"),
          _createElementVNode("button", {
            type: "button",
            class: "btn table-btn btn-outline-secondary",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.cancelEditProblem()))
          }, " Cancel ")
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.isAddRequested)
      ? (_openBlock(), _createElementBlock("td", _hoisted_42, [
          _createElementVNode("button", {
            type: "button",
            class: "btn table-btn btn-outline-success",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.save()))
          }, "Add"),
          _createElementVNode("button", {
            type: "button",
            class: "btn table-btn btn-outline-secondary",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.cancelSaveNewProblem()))
          }, " Cancel ")
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}